import React, { useRef, useState } from 'react'
import IndustriesImageContainer from './../../components/IndustriesImageContainer';
import IndustriesStickyMenu from './../../components/IndustriesStickyMenu';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import Navbar from './../../components/Navbar';
import Footer from './../../components/Footer';
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import certificates_permits_licenses_img from "../../assets/images/contents/certificates-permits-licenses-1.png"
import { PrimaryButton } from '../../components/StyledButtons';
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm';

const CertificatesPermitsLicenses = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const modalDiscussionRef = useRef(null);
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
  };
  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };

  return (
    <div className='certificates-permits-licenses bg-primary'>
      <div className='color-filter-right' style={{ top: "20%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "52%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid certificates-permits-licenses-header pb-100'>
        <div className='container'>
          {language === "en" ?
            <div className='col-sm-12 pt-150'>
              <div className='font-weight-bold text-center font-64 certificates-permits-licenses-header-title'>Certificates, Permits & Licenses</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
            :
            <div className='col-sm-10 col-sm-offset-1 pt-150'>
              <div className='font-weight-bold text-center font-64 certificates-permits-licenses-header-title'>Giấy chứng nhận, Giấy phép & Giấy phép</div>
              <div className='col-sm-12 px-md-0'>
                <div className='underline-orange'></div>
              </div>
            </div>
          }
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.certificates-permits-licenses')} linkToPrevPage="/industries" />
          </div>
        </div>


      </div>
      <div className='certificates-permits-licenses-content container'>
        <div className='row flex-lg'>
          <div className='col-lg-w-400'>
            <IndustriesStickyMenu governmentActive={true} certificatesPermitsLicensesActive={true} />
          </div>
          <div className='col-lg-w--400 certificates-permits-licenses-content_info'>
            <p className='font-48 font-weight-semibold text-white'>{t('certificates-permits-licenses.title')}</p>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('certificates-permits-licenses.sub-title-1')}</p>
            <p className='text-white pt-20'>{t('certificates-permits-licenses.content-1')}</p>
            <p className='text-white pt-20'>{t('certificates-permits-licenses.content-2')}</p>
            <p className='text-white pt-20'>{t('certificates-permits-licenses.content-3')}</p>
            <div style={{ overflowX: "auto" }} className='pt-20'>
              <table>
                <thead>
                  <tr>
                    <th>{t('certificates-permits-licenses.table.agriculture-and-veterinary')}</th>
                    <th>{t('certificates-permits-licenses.table.civil-aviation-documents')}</th>
                    <th>{t('certificates-permits-licenses.table.building-and-construction')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('certificates-permits-licenses.table.health-and-safety')}</td>
                    <td>{t('certificates-permits-licenses.table.shipping-and-transportation')}</td>
                    <td>{t('certificates-permits-licenses.table.homeland-security')}</td>
                  </tr>
                  <tr>
                    <td>{t('certificates-permits-licenses.table.urban-and-land-use')}</td>
                    <td>{t('certificates-permits-licenses.table.police')}</td>
                    <td>{t('certificates-permits-licenses.table.commercial-licensing')}</td>
                  </tr>
                  <tr>
                    <td>{t('certificates-permits-licenses.table.revenue-and-customs')}</td>
                    <td>{t('certificates-permits-licenses.table.medical-legal-councils')}</td>
                    <td>{t('certificates-permits-licenses.table.corporate-regulatory')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('certificates-permits-licenses.sub-title-2')}</p>
            <p className='text-white pt-20'>{t('certificates-permits-licenses.content-4')}</p>
            <p className='text-white pt-20'>{t('certificates-permits-licenses.content-5')}</p>
            <div className='pt-50'>
              <img src={certificates_permits_licenses_img} alt="" className='img-responsive' />
            </div>
            <div className='col-sm-12 pt-30 px-0'>
              <ul className='list-unstyled pt-20'>
                <li className='checked-line'>{t('certificates-permits-licenses.content-6-1')}</li>
                <li className='checked-line'>{t('certificates-permits-licenses.content-6-2')}</li>
                <li className='checked-line'>{t('certificates-permits-licenses.content-6-3')}</li>
                <li className='checked-line'>{t('certificates-permits-licenses.content-6-4')}</li>
                <li className='checked-line'>{t('certificates-permits-licenses.content-6-5')}</li>
              </ul>
            </div>
            <div className='col-sm-12 pt-30'>
              <div className='row'>
                <PrimaryButton
                onClick={() => setModalDiscussionOpen(true)}
                >{t('button.schedule-discussion')}</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <IndustriesImageContainer />
      </div>

      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default CertificatesPermitsLicenses